/* TBS 2026-10-21: move the Discount Yard widget (#stack-discounts-container), which the app prepends
   into SessionFlow's sticky .sf-cart-footer, into the scrolling .sf-cart-body after the line items. */
(function () {
  function move() {
    var root = document.querySelector('.sf-cart-root') || document;
    var body = root.querySelector('.sf-cart-body');
    if (!body) return;
    var footer = root.querySelector('.sf-cart-footer');
    var inFooter = footer && footer.querySelector('#stack-discounts-container');
    if (!inFooter) return;
    var block = inFooter;
    while (block.parentElement && block.parentElement !== footer) block = block.parentElement;
    /* drop any stale copy already moved, keep the freshest one from the app */
    body.querySelectorAll(':scope > .tbs-dy-moved').forEach(function (el) { if (el !== block) el.remove(); });
    block.classList.add('tbs-dy-moved');
    var lines = body.querySelector(':scope > .sf-cart-lines');
    if (lines) lines.insertAdjacentElement('afterend', block); else body.appendChild(block);
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(move, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', move);
})();